import React, {useEffect, useRef} from "react";
import {observer} from "mobx-react-lite";
import appStore from "../../../storage/AppStore";
import clubStore from "../../../storage/ClubStore";
import Input from "../../../ui/Input";
import Select from "../../../ui/Select";
import Btn from "../../../ui/Btn";
import NoResult from '../../NoResult/NoResult'
import {Link} from "react-router";

const Members = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
        clubStore.memberQuery.setProperty('page_number', 1);
        clubStore.getMembers();
    }, []);

    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = window.scrollY;
            const windowHeight = window.innerHeight;
            const fullHeight = document.body.offsetHeight;

            if (scrollTop + windowHeight >= fullHeight - 100) {
                // Near the bottom
                clubStore.getMembersMore();
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <div className="row justify-content-center">
            <div className="flex flex-row w-100 justify-content-between px-3 my-2">
                <div className="flex align-items-center">
                    <b className="card-header">{appStore.tr.club_members} ({clubStore.memberQuery.count})</b>
                </div>
                <div className="flex align-items-center">
                    <Link to="/manager/member/new" className="btn btn-sm btn-icon btn-success align-self-end">
                        <i className="ci-user-plus"/>
                    </Link>
                </div>
            </div>
            <div className="col-12 px-3">
                <form className="form-inline mb-3" noValidate="">
                    <div className="row">
                        <div className="col-lg-5 col-sm-6 col-xs-6 mb-1">
                            <Input store={clubStore.memberQuery} prop={'name'} label={appStore.tr.search}/>
                        </div>
                        <div className="col-lg-5 col-sm-6 col-xs-6 mb-1">
                            <Select
                                store={clubStore.memberQuery}
                                prop={'role_id'}
                                label={appStore.tr.role}
                                options={appStore.rolesLocalized}
                                for_search={true}
                            />
                        </div>

                        <div className="col-lg-2 col-sm-12 col-xs-12 mb-1">
                            <Btn
                                className={"btn btn-sm btn-primary w-100"}
                                onClick={() => {
                                    clubStore.memberQuery.setProperty('page_number', 1);
                                    clubStore.getMembers()
                                }}
                            ><i className="ci ci-search me-2"/>{appStore.tr.search}</Btn>
                        </div>
                    </div>
                </form>
            </div>
            {clubStore.members.length === 0 &&
                <NoResult/>
            }
            {clubStore.members.map((member, index) => (
                <div key={index} className="col-lg-3 col-md-6 col-sm-12 col-xs-12 px-3 d-flex mb-3">
                    <div className="card mb-3 shadow-sm h-100 w-100 d-flex flex-column">
                        <div className="card-body d-flex flex-column">
                            <div>
                                <h6 className="mb-1">
                                    {member.title} {member.role_id === 'MMBR' && <>#{member.forma_number}, {member.year_born}</>}
                                </h6>
                                <p className="mb-1 text-muted">{member.role?.name}</p>
                                {member.role_id === 'MMBR' && (
                                    <>
                                        {member.mother_id && (
                                            <>
                                                <small className="text-muted">
                                                    {appStore.tr.mother}: <span
                                                    className="text-secondary">{member.mother.title}</span>
                                                </small><br/>
                                            </>
                                        )}
                                        {member.father_id && (
                                            <small className="text-muted">
                                                {appStore.tr.father}: <span
                                                className="text-secondary">{member.father.title}</span>
                                            </small>
                                        )}
                                    </>
                                )}
                            </div>

                            {/* Inline small buttons */}
                            <div className="mt-auto pt-3">
                                {/*<div className="btn-group btn-group-sm" role="group">*/}
                                {/*    <button className="btn btn-outline-primary">Show</button>*/}
                                {/*    <button className="btn btn-outline-secondary">Edit</button>*/}
                                {/*    <button className="btn btn-outline-danger">Delete</button>*/}
                                {/*</div>*/}
                            </div>

                            {/* Main action buttons aligned to bottom */}
                            <div className="mt-auto pt-3">
                                <div className="d-grid gap-2">
                                    <div className="btn-group btn-group-sm" role="group">
                                        <button className="btn btn-outline-primary">Show</button>
                                        <button className="btn btn-outline-secondary">Edit</button>
                                        <button className="btn btn-outline-danger">Delete</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
}

export default observer(Members);